import React from 'react';

const NotFound = () => <div>Yikes! This is not the information that you are looking for... </div>;

export default NotFound;
